import { PcApiResponse } from '@/api/pc-api/types';
import { StatType } from '@/api/pc-api/v1/{authInfoId}/service-stat/type';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  statType: StatType;
  statDate: string;
  size: number;
};

export type CompleteRankings = {
  averageCompleteRatio: number;
  completeRanking: CompleteRanking[];
};

export type CompleteRanking = {
  id: string;
  requestOrganizationName: string;
  requestTitle: string;
  requestCount: number;
  completeCount: number;
  completeRatio: number;
};

export const getCompleteRanking = (args: Args) => {
  return api<PcApiResponse<CompleteRankings>>('get', `/pc-api/v1/${PREFIX_PATH}/service-stat/complete-ranking`, args);
};
